import React from 'react';
import { Stack, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';

type Props = {
  readonly errorMessage?: string;
  readonly stackTrace?: string;
}

const DeploymentErrorFields = (props: Props) => {
  const { errorMessage, stackTrace } = props;

  return (
    <Stack spacing={2}>
      <div style={{ marginTop: 10, color: '#ff0000' }}>
        <Typography variant='caption'>Error message</Typography>
        <Typography>{errorMessage}</Typography>
      </div>
      { stackTrace && (
        <div>
          <Typography variant='caption'>Stack trace</Typography>
          <Paper style={{ backgroundColor: '#F5F5F5', padding: 15, margin: 5 }}>
            <span style={{ fontFamily: 'Monospace', wordBreak: 'break-word' }}>
              {stackTrace}
            </span>
          </Paper>
        </div>
      )}
    </Stack>
  );
};

export default DeploymentErrorFields;
